export const MODAL_NAME = 'orders.recap'
export const FINANCIAL_DETAILS = 'financial-details'
export const ORDER_DETAILS = 'order-details'
